import styled from 'styled-components';
import {
  maxMobile,
  maxTablet,
  maxWidth, primaryFont, primaryHeadingColor, retina, secondaryFont, smMobile, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { Row, Col, Button } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import { selectFollowedIndustries, selectIndustriesEmpty, selectLoading } from 'Selector/IndustriesSelector';

import React, { useEffect, useState } from 'react';

import IndustriesSkeleton from 'Components/common/skeleton/IndustriesSkeleton';
import { Industry } from 'Types/IndustryTypes';
// import { actions } from 'Slice/IndustriesSlice';
import { actions } from 'Slice/IndustriesSlice';
import {
  allValueInKeyOfArrayExists, formatNumberWithCommas, IsMobile, IsTablet,
} from 'Utils/UtilityFunctions';
import { translateSkipAreas, TOOLTIP_INDUSTRIES, VIDEO_INDUSTRIES } from 'Utils/Constants';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import Cross from 'Components/globalSearch/assets/Cross';
import EditIcon from '../company/svgIcons/EditIcon';
import BinIcon from '../company/svgIcons/BinIcon';
import IndustriesWidget from '../common/components/IndustriesWidget';

const StyleWrapper = styled.div`
  padding-bottom: 120px;
  @media all and (max-width: ${maxMobile}) {
    padding-bottom: 50px;
  }
  .fancy-box {
    border-radius: 10px;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.14);
    background: rgb(255, 255, 255);
    padding: 40px 50px 40px 50px;
    margin-top: 50px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 17px 16px 16px 16px;
    }

    .tabs-wrapper {
      margin-right: 5px;
      @media all and (max-width: ${maxTablet}) {
        .icon-button {
          padding: 7px;
          svg {
            height: 18px;
            path {
              fill: #7E7E7E;
            }
          }
        }
      }
    }
    .heading-row {
      padding: 0px 4px 0px 10px;
      @media all and (max-width: ${smMobile}) {
        flex-direction: column;
      }
      .second-side {
        @media all and (max-width: ${smMobile}) {
          justify-content: flex-end;
          margin-top: 20px;
          width: 100%;
        }
      }
    }
    .heading {
      font-size: 28px;
      line-height: 30px;
      font-weight: ${wMedium};
      font-family: ${secondaryFont};
      margin-bottom: 0px;
      margin-left: 20px;
      color: ${primaryHeadingColor};
      @media all and (max-width: ${maxWidth}) , ${retina} { 
        font-size: 24px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 19px;
      }
      @media all and (max-width: ${smMobile}) {
        width: 100%;
      }
    }
    p {
      font-family: ${primaryFont};
      color: #5e7079;
    }
    input {
      font-size: 16px;
      padding: 7px 12px;
    }
    label {
      font-size: 12px;
    }
    h4.recommended-name{
      color:${primaryHeadingColor};
      font-weight: ${wMBold};
      font-family:${secondaryFont};
      margin-bottom:0;
      font-size:22px;
      line-height: 38px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 18px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 14px;
        line-height: 19px;
      }
    }
  }
  .industriesSection {
    margin-top: 20px;
    .search-distance-row{
      margin: 0 !important;
    }
  }
`;

const IndustriesSection = function IndustriesSection() {
  const industriesStore = useSelector(selectFollowedIndustries);
  const loading = useSelector(selectLoading);
  const emptyIndustries = useSelector(selectIndustriesEmpty);
  const [editEnable, setEditEnable] = useState(false);
  const [industries, setIndustries] = useState<Industry[]>([]);
  const dispatch = useDispatch();
  const isTab = IsTablet();
  const isMob = IsMobile();
  const formattedIndustriesCount = formatNumberWithCommas(industries.length);

  const getCompaniesLoadingSkeleton = () => {
    const skeletons = [];
    for (let i = 0; i < 6; i += 1) {
      skeletons.push(
        <Col span={4} className="gutter-row">
          <IndustriesSkeleton />
        </Col>,
      );
    }
    return (
      skeletons
    );
  };

  const setInitialIndustries = () => {
    const industriesTemp = industriesStore.map((v) => ({ ...v, selected: false }));
    setIndustries(industriesTemp);
  };
  useEffect(() => {
    setInitialIndustries();
    if (editEnable && !loading) {
      setEditEnable(!editEnable);
    }
  }, [industriesStore]);
  const setChecked = (flag: boolean, id: number) => {
    const industriesT = industries.map((v) => {
      if (id === v.id) {
        return { ...v, selected: !flag };
      }
      return v;
    });
    setIndustries(industriesT);
  };
  const removeIndustries = () => {
    const industriesTemp = industries.filter((v) => v.selected === true);
    dispatch(actions.removingIndustries(industriesTemp));
  };

  const unFollowingIndustry = (industry: Industry[]) => {
    dispatch(actions.removeIndustry(industry));
  };

  return (!emptyIndustries
    ? (
      <StyleWrapper>
        <div className="fancy-box">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="d-flex align-items-center heading">
              {isMob ? (
                <>
                  My industries (
                  <span className={` ${translateSkipAreas}`}>{(formattedIndustriesCount)}</span>
                  )
                </>
              ) : (
                <>
                  Industries I follow
                  {' '}
                  {' '}
                  {' '}
                  (
                  <span className={` ${translateSkipAreas}`}>{(formattedIndustriesCount)}</span>
                  )
                </>
              )}
              <HeadingWithToolTip
                heightIconXSm="17px"
                heightIcon="16px"
                heightIconSm="18px"
                toolTipText={TOOLTIP_INDUSTRIES}
                videoLink={VIDEO_INDUSTRIES}
              />
            </h1>
            <div className="tabs-wrapper second-side">
              {!editEnable ? (
                <Button
                  className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                  onClick={() => { setEditEnable(true); }}
                  disabled={loading}
                  aria-label="Edit"
                >
                  <EditIcon />
                  {isTab ? null : (
                    <span style={{
                      marginLeft: '10px',
                      marginRight: '8px',
                    }}
                    >
                      Edit
                    </span>
                  )}
                </Button>
              ) : (
                <>

                  <Button
                    className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                    disabled={loading || allValueInKeyOfArrayExists(industries, 'selected', false)}
                    onClick={removeIndustries}
                    aria-label="Delete"
                  >
                    <BinIcon />
                    {isTab ? null : (
                      <span style={{
                        marginLeft: '10px',
                        marginRight: '8px',
                      }}
                      >
                        Remove
                      </span>
                    )}
                  </Button>
                  <Button
                    className="tabs-item icon-button d-flex justify-content-center align-items-center radius-50 ml-1"
                    onClick={() => { setEditEnable(false); setInitialIndustries(); }}
                    aria-label="Cancel"
                    disabled={loading}
                  >
                    {isTab ? (
                      <Cross />
                    ) : (
                      <span>Cancel</span>
                    )}
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="industriesSection">
            <Row className="Grid-width-row white-layer-col" gutter={[24, 24]}>
              {loading ? getCompaniesLoadingSkeleton()
                : industries.map((industry) => (
                  <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row">
                    <IndustriesWidget
                      key={industry.id}
                      id={industry.id}
                      articleText={industry.name}
                      articleBanner={industry.fullimage}
                      removeButton={editEnable}
                      showUnfollow
                      checked={industry.selected}
                      setChecked={(flag) => setChecked(flag, industry.id)}
                      isAdded={industry.added}
                      followLoading={industry.loading}
                      unFollowingIndustry={() => unFollowingIndustry([industry])}
                    />
                  </Col>
                ))}
            </Row>
            {/* </div> */}
          </div>
        </div>
      </StyleWrapper>
    ) : null
  );
};
export default IndustriesSection;
